import styled from "styled-components";
import { Icon } from "@iconify/react";

interface ButtonProps {
  color?: string;
  background?: string;
}

const Button = styled.button<ButtonProps>`
  width: 257px;
  margin: 50px auto;
  padding: 14px;
  background-color: ${(props) => props.background || "#E4DA1B"};
  color: ${(props) => props.color || "#fff"};
  font-size: 14px;
  font-weight: 700;
  border: none;
  border-radius: 22px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
`;

const ButtonTestFree = ({ light = true }) => {
  const redirect = () => {
    if (window.fbq) {
      window.fbq("trackCustom", "ClickCriarConta");
    }
    window.location.href = "/redirect";
  };

  return (
    <Button
      onClick={redirect}
      color={light ? "#000000" : "#E4DA1B"}
      background={light ? "#E4DA1B" : "#000000"}
    >
      Teste Grátis por 3 dias
      <Icon
        icon="mdi:arrow-right"
        width={18}
        height={18}
        color={light ? "#000000" : "#E4DA1B"}
      />
    </Button>
  );
};

export default ButtonTestFree;
